import { __makeTemplateObject, __assign } from '../../node_modules/tslib/tslib.es6.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import React from 'react';
import styled from 'styled-components';

var StyledCollage = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  max-width: ", ";\n  display: flex;\n  gap: 14px;\n  justify-content: center;\n  align-self: center;\n\n  ", "\n\n  & img {\n    border-radius: ", ";\n    max-width: 100%;\n    height: auto;\n    filter: drop-shadow(0 3px 6px rgba(0, 0, 0, 0.05)) drop-shadow(0 10px 20px rgba(0, 0, 0, 0.1));\n  }\n"], ["\n  position: relative;\n  max-width: ", ";\n  display: flex;\n  gap: 14px;\n  justify-content: center;\n  align-self: center;\n\n  ", "\n\n  & img {\n    border-radius: ", ";\n    max-width: 100%;\n    height: auto;\n    filter: drop-shadow(0 3px 6px rgba(0, 0, 0, 0.05)) drop-shadow(0 10px 20px rgba(0, 0, 0, 0.1));\n  }\n"])), function (_a) {
  var isOverlapping = _a.isOverlapping;
  return isOverlapping ? '520px' : '720px';
}, function (_a) {
  var hasBackgroundSquare = _a.hasBackgroundSquare,
    theme = _a.theme;
  return hasBackgroundSquare && "\n  &::before {\n    content: '';\n    display: block;\n    position: absolute;\n    background-color: ".concat(theme.designTokens.colors.secondary30, ";\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    width: 50%;\n    height: 50%;\n    border-radius: ").concat(theme.borderRadius[2], ";\n  }\n  ");
}, function (_a) {
  var theme = _a.theme;
  return theme.borderRadius[2];
});
var FirstColumn = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: ", ";\n  gap: 14px;\n  align-items: end;\n  flex: 1;\n  margin-top: ", ";\n"], ["\n  display: flex;\n  flex-direction: ", ";\n  gap: 14px;\n  align-items: end;\n  flex: 1;\n  margin-top: ", ";\n"])), function (_a) {
  var isReverse = _a.isReverse;
  return !isReverse ? 'column-reverse' : 'column';
}, function (_a) {
  var isReverse = _a.isReverse;
  return !isReverse && '80px';
});
var SecondColumn = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: ", ";\n  gap: 14px;\n  flex: 1;\n  margin-left: ", ";\n  margin-top: ", ";\n"], ["\n  display: flex;\n  flex-direction: ", ";\n  gap: 14px;\n  flex: 1;\n  margin-left: ", ";\n  margin-top: ", ";\n"])), function (_a) {
  var isReverse = _a.isReverse;
  return isReverse ? 'column-reverse' : 'column';
}, function (_a) {
  var isOverlapping = _a.isOverlapping;
  return isOverlapping && '-200px';
}, function (_a) {
  var isReverse = _a.isReverse;
  return isReverse && '80px';
});
var Square = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: block;\n  background-color: #ee3224;\n  ", ";\n  border-radius: ", ";\n  margin-left: ", ";\n  margin-right: ", ";\n  z-index: 1;\n"], ["\n  display: block;\n  background-color: #ee3224;\n  ", ";\n  border-radius: ", ";\n  margin-left: ", ";\n  margin-right: ", ";\n  z-index: 1;\n"])), function (_a) {
  var redSquareSize = _a.redSquareSize;
  return "\n    width: ".concat(redSquareSize, ";\n    height: ").concat(redSquareSize, ";\n  ");
}, function (_a) {
  var theme = _a.theme;
  return theme.borderRadius[2];
}, function (_a) {
  var isOverlapping = _a.isOverlapping,
    isReverse = _a.isReverse;
  return isOverlapping && !isReverse && '200px';
}, function (_a) {
  var isOverlapping = _a.isOverlapping,
    isReverse = _a.isReverse;
  return isOverlapping && isReverse && '200px';
});
/**
 * The Collage component
 *
 * @param {CollageProps} props - The props for the Collage component.
 * @returns {JSX.Element} The Collage component.
 */
var Collage = function (_a) {
  var children = _a.children,
    variant = _a.variant;
  var collageItems = React.Children.toArray(children);
  var hasThree = collageItems.length === 3;
  var _b = ['reverse', 'overlapping', 'background-square'].map(function (value) {
      return !!(variant === null || variant === void 0 ? void 0 : variant.includes(value));
    }),
    isReverse = _b[0],
    isOverlapping = _b[1],
    hasBackgroundSquare = _b[2];
  // eslint-disable-next-line no-nested-ternary
  var redSquareSize = (variant === null || variant === void 0 ? void 0 : variant.includes('red-square-size-l')) ? '72px' : (variant === null || variant === void 0 ? void 0 : variant.includes('red-square-size-m')) ? '48px' : '32px';
  var variantProps = {
    isReverse: isReverse,
    isOverlapping: isOverlapping,
    hasBackgroundSquare: hasBackgroundSquare,
    redSquareSize: redSquareSize
  };
  var renderCollage = function () {
    return jsxs(Fragment, {
      children: [jsxs(FirstColumn, __assign({}, variantProps, {
        children: [!isReverse && hasThree && collageItems[1], collageItems[0], isReverse && jsx(Square, __assign({}, variantProps))]
      })), jsxs(SecondColumn, __assign({}, variantProps, {
        children: [!hasThree && collageItems[1], hasThree && collageItems[2], isReverse && hasThree && collageItems[1], !isReverse && jsx(Square, __assign({}, variantProps))]
      }))]
    });
  };
  return jsx(StyledCollage, __assign({}, variantProps, {
    children: renderCollage()
  }));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;

export { Collage };
//# sourceMappingURL=Collage.js.map
